import React from "react";
import {
  LogoContainer,
  NavbarContainer,
  MenuContainer,
  NavItem,
  LoginButtonHeader,
} from "./index.styled";
import { CustomButton } from "../buttons/index.styled";
import { env } from "../../.env";

const NavbarLanding = () => {
  const menuItems = [
    { id: 0, content: "آوانگار چیست", path: "aboutAvanegar" },
    { id: 1, content: "ویژگی ها", path: "features" },
    { id: 2, content: "کاربردها", path: "usages" },
    { id: 3, content: "مشتریان ما", path: "customers" },
    { id: 4, content: "تماس با ما", path: "contacts" },
  ];

  /**
   * @desc link handler. after click user redirect to https://test-avanegar.partdp.ir/
   * @function
   */
  const linkHandler = () => {
    window.location.href = env.REACT_APP_PANEL_REDIRECT;
  };
  return (
    <NavbarContainer className="container">
      <LogoContainer>
        <h2>
          <span>آوا</span>نــگـــــار
        </h2>
      </LogoContainer>

      <MenuContainer>
        {menuItems.map((item) => (
          <NavItem key={item.id}>
            <a href={`#${item.path}`}>{item.content}</a>
          </NavItem>
        ))}
      </MenuContainer>
      <LoginButtonHeader>
        <CustomButton
          width="138px"
          height="48px"
          radius="2px"
          background="#12A46F"
          borderColor="#12A46F"
          backgroundHover="#FFFFFF"
          borderColorHover="#12A46F"
          colorHover="#12A46F"
          fontWeight="700"
          onClick={linkHandler}
        >
          ورود به حساب
        </CustomButton>
      </LoginButtonHeader>
    </NavbarContainer>
  );
};

export default NavbarLanding;
